import { call } from 'redux-saga/effects';
import { getRisk as getRiskBit } from '../bitSagas/getRisk';

const normalizeRiskResponse = (response) => {

  if(response?.customerCreditProfile && response?.riskResponseCause){
    const { customerCreditProfile, riskResponseCause } = response;
    
    return {
      creditLimit: customerCreditProfile.creditLimit,
      monthlyCreditLimit: customerCreditProfile.monthlyCreditLimit,
      hasDebt: riskResponseCause.name === '420' ? true : false,
      unknownRisk: riskResponseCause.name !== '200' && riskResponseCause.name !== '420',
      riskCode: riskResponseCause.name
    }
  }

  return null;
}

export function* getRisk(params) {
  const { showError, normalizeHttpErrors } = params;
  const reduxUpdate = { errorUpdate: showError };

  const getRiskParams = {
    normalizeHttpErrors,
    reduxUpdate,
  };

  try {
    const response = yield call(getRiskBit, getRiskParams);
    const responseNormalized = normalizeRiskResponse(response, )
    return responseNormalized;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
